import type { IconProps } from '../types/IconProps.ts';
export const Mic: IconProps = {
    name: 'Mic',
    children: [
        `<rect width="6" height="13" x="9" y="2" rx="3" />`,
        `<path d="M5 10v2a7 7 0 0 0 7 7m7-9v2a7 7 0 0 1-7 7m0 0v3" />`,
    ]
};